import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberStatusBadgeComponent } from './member-status-badge.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
  ],
  declarations:[MemberStatusBadgeComponent],
  exports:[MemberStatusBadgeComponent],
})
export class MemberStatusBadgeModule { }
